import { render, staticRenderFns } from "./comHit.vue?vue&type=template&id=92f92b40&scoped=true&"
import script from "./comHit.vue?vue&type=script&lang=js&"
export * from "./comHit.vue?vue&type=script&lang=js&"
import style0 from "./comHit.vue?vue&type=style&index=0&id=92f92b40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92f92b40",
  null
  
)

export default component.exports